import { type AxiosRequestHeaders } from 'axios';
import _ from 'lodash';
import { AxiosInstanceManager } from '../managers/axios-instance-manager';
import { useRestHeaderStore } from '../stores/restHeaderStore';
import { getRefreshUrl, JwtErrorCodes, NormalizedJwtResponse } from './jwt-commons';
import { JwtProcessStateManager } from './jwt-process-state';
import { JwtTokenRepository } from './jwt-token-repository';

let processManager: JwtProcessStateManager = JwtProcessStateManager.getInstance();
let tokenManager: JwtTokenRepository = JwtTokenRepository.getInstance();

/**
 * 로그인(토큰 신규 발급) 응답 표준화 처리
 * @param response
 * @returns
 */
export const resolveLoginResponse = (response: any): NormalizedJwtResponse => {
    const rawData = response?.data;
    const bizData = rawData?.data;

    return {
        isSuccess: !rawData.error && bizData?.accessToken && bizData?.refreshToken,
        accessToken: bizData?.accessToken,
        refreshToken: bizData?.refreshToken,
        httpStatus: response?.status,
    };
};

/**
 * 토큰 재발급 응답 표준화 처리
 * @param response
 * @returns
 */
export const resolveRefreshResponse = (response: any): NormalizedJwtResponse | null => {
    const rawData = response?.data;
    const bizData = rawData?.data;

    return {
        isSuccess: !rawData.error && bizData?.accessToken && bizData?.refreshToken,
        accessToken: bizData?.accessToken,
        refreshToken: bizData?.refreshToken,
        httpStatus: response?.status,
    };
};

/**
 * 토큰 재발급 처리
 * @param error
 * @returns
 */
export const requestRefreshToken = async (error: any) => {
    const refreshToken = tokenManager.getRefreshToken();
    console.log('jwt-resolvers > requestRefreshToken(재발급요청) - refreshToken : ', refreshToken);

    // 재발급 시도 시 RT가 없는 경우
    if (!refreshToken || _.isEmpty(_.trim(refreshToken))) {
        return processManager.handleJwtError(JwtErrorCodes.NO_REFRESH_TOKEN);
    }

    console.log('jwt-resolvers > requestRefreshToken(재발급요청) - refreshInfo : ', {
        retry: error?.config?._retry,
        httpStatus: error?.response?.status,
        nowHandling401: processManager.isNowHandling401(),
        nowHandling403: processManager.isNowHandling403(),
        failQueue: processManager.getFailedQueue(),
    });

    try {
        const baseUrl = error.config.baseURL;
        const refreshUrl = getRefreshUrl(error);

        console.log('jwt-resolvers > requestRefreshToken(재발급요청) - refreshUrlInfo ', {
            baseUrl,
            refreshUrl,
        });

        if (!baseUrl || !refreshUrl) {
            return processManager.handleJwtError(JwtErrorCodes.INVALID_REFRESH_URL);
        }

        let contextHeader = useRestHeaderStore.getState().getRestRequestHeader();

        const jwtHeader = {
            'X-Refresh-Token': refreshToken,
        };

        const headers = _.merge({}, contextHeader, jwtHeader);
        const omittedHeaders = _.omitBy(headers, _.isUndefined) as AxiosRequestHeaders;

        const axiosClient = AxiosInstanceManager.getCommonAxiosInstance(baseUrl);
        return await axiosClient.post(
            refreshUrl,
            {},
            {
                headers: omittedHeaders,
            },
        );
    } catch (refreshError) {
        console.log(
            'jwt-resolvers > requestRefreshToken(재발급요청) - refreshError ',
            refreshError,
        );
        return processManager.handleJwtError(JwtErrorCodes.REFRESH_FAILURE);
    }
};
